export default __webpack_public_path__ + "static/media/inefop_services_small.67a6cf5e.png";